import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import {Checkbox} from '../../../../uikit/Checkbox';
import {not} from '../../../../utils/conditionalUtils';
import {isUserEmployee, isUserHasRole} from '../../../../utils/entity/user';
import {envManager} from '../../../../utils/env';
import {storage} from '../../../../utils/storage';
import {DONT_SHOW_CONFERENCE_FEEDBACK_STORAGE_KEY} from '../../utils';
import * as S from './styles';

type Props = {
  role: 'client' | 'coach';
};

const checkShouldShow = (role: Props['role']) => {
  if (envManager.isB2b) {
    return false;
  }

  switch (role) {
    case 'client':
      return not(isUserEmployee());
    case 'coach':
      return not(isUserHasRole('approved_corporate_coach'));
    default:
      return true;
  }
};

export const DontShowConferenceRatingCheckbox: FC<Props> = ({role}) => {
  const {t} = useI18n();

  if (not(checkShouldShow(role))) {
    return null;
  }

  const setIsDontShowAgainChecked = (value: boolean) => {
    storage.setItem(DONT_SHOW_CONFERENCE_FEEDBACK_STORAGE_KEY, String(value));
  };

  return (
    <S.CheckboxContainer>
      <Checkbox
        controlled
        onClick={({payload}) =>
          setIsDontShowAgainChecked(Boolean(payload?.checked))
        }
      />
      <S.CheckboxLabel>{t('shared:dont_show_me_again')}</S.CheckboxLabel>
    </S.CheckboxContainer>
  );
};
